<template>
    <div class="image-preview">
      <image-component :image="image" :width="image.width" :height="image.height"></image-component>
      <div class="rect" v-for="item in results" :style="item.style">
        <p>{{item.name}}</p>
        <p>{{item.colorName}}</p>
      </div>
    </div>
</template>
<script type="text/babel">
  export default {
    components: {},
    props:{
      jsonObj:Object
    },
    data(){
      return {

      }
    },
    computed:{
      image(){
        let width = this.jsonObj.width > 850 ? 850 : this.jsonObj.width,
            height = this.jsonObj.width > 850 ? width / (this.jsonObj.width / this.jsonObj.height) : this.jsonObj.height;
        return {
          image:this.jsonObj.image,
          width:width,
          height:height
        }
      },
      results(){
        let results = this.jsonObj && this.jsonObj.detect && _.toArray(this.jsonObj.detect.results),
            rectList = []
        _.each(results, item => {
          rectList.push({
            name:item.item,
            colorName:item.colorName,
            style:this.getStyle(item.colors[0],item.box)
          })
        })
        return rectList
      }
    },
    ready(){

    },
    methods: {
      getStyle(colors,box){
        let RGBStyle = this.getRGBStyle(colors),
            positionStyle = this.getPositionStyle(box)

        return Object.assign({},RGBStyle,positionStyle)
      },
      getRGBStyle(colors){
        return {
          background:`rgba(${colors[0]},${colors[1]},${colors[2]},.8)`
        }
      },
      getPositionStyle(box){
        let imgW = this.jsonObj.width > 850 ? 850 : this.jsonObj.width,
            imgH = this.jsonObj.width > 850 ? imgW / (this.jsonObj.width / this.jsonObj.height) : this.jsonObj.height
        let _box = _.map(box,item=>{
          return item.toFixed(8)
        })
        let [x,y,width,height] = _box
        let _width = width * (imgW / this.jsonObj.width)
        let _height = height * (imgH / this.jsonObj.height)
        let _x = (x - width * 0.5).toFixed(2) / this.jsonObj.width * imgW
        let _y = (y - height * 0.5).toFixed(2) / this.jsonObj.height * imgH
        return {
          top: _y+'px',
          left: _x+'px',
          width: _width+'px',
          height: _height+'px'
        }
      }
    }
  }
</script>
<style lang="less" scoped>
  .image-preview {
    position: relative;
    overflow-x: auto;
    .rect {
      position: absolute;
      color:#fff;
      font-size: 18px;
    }
  }
</style>
